// extracted by mini-css-extract-plugin
export default {"Block":"Block_Block__8s6w8","block_name":"Block_block_name__aL+c2","block_content":"Block_block_content__+kRig"};